import { observable } from 'mobx';
import moment from 'moment';
import type { Moment } from '../../lib/moment';
import OrganizationOperationRuleField, {
  convertOrganizationOperationRuleFieldResponseToArgs,
  type OrganizationOperationRuleFieldArgs,
  type OrganizationOperationRuleFieldResponseArgs
} from './organization_operation_rule_field';

export type OrganizationOperationRuleResponseArgs = {
  name: string | null;
  salesforce_id: string;
  synced_at: string;
  salesforce_updated_at: string;
  fields: OrganizationOperationRuleFieldResponseArgs[];
};

export type OrganizationOperationRuleArgs = {
  name: string | null;
  salesforceId: string;
  syncedAt: Moment;
  salesforceUpdatedAt: Moment;
  fields: OrganizationOperationRuleFieldArgs[];
};

export const convertOrganizationOperationRuleResponseToArgs = (
  response: OrganizationOperationRuleResponseArgs
): OrganizationOperationRuleArgs => ({
  name: response.name,
  salesforceId: response.salesforce_id,
  syncedAt: moment(response.synced_at),
  salesforceUpdatedAt: moment(response.salesforce_updated_at),
  fields: (response.fields || []).map(convertOrganizationOperationRuleFieldResponseToArgs)
});

export default class OrganizationOperationRule {
  @observable name: string | null;
  @observable salesforceId: string;
  @observable syncedAt: Moment;
  @observable salesforceUpdatedAt: Moment;
  @observable fields: OrganizationOperationRuleField[];

  constructor(args: OrganizationOperationRuleArgs) {
    this.name = args.name;
    this.salesforceId = args.salesforceId;
    this.syncedAt = args.syncedAt;
    this.salesforceUpdatedAt = args.salesforceUpdatedAt;
    this.fields = args.fields.map(field => new OrganizationOperationRuleField(field));
  }
}
